import * as types from './constants'

const intialState = {
	locationCloneStatus: '',
	locationCloned: null,
	cloneId: null,
	showSelectedLocations: false,
	locationSearchValue: '',
	searchValueOnClick: '',
	associatedGroupSearchValue: '',
}
// eslint-disable-next-line import/no-anonymous-default-export
const locationReducer = (state = intialState, action) => {
	switch (action.type) {
		case types.LOCATION_CLONE_STATUS:
			return {
				...state,
				locationCloneStatus: action.status,
			}
		case types.RESET_LOCATIONS:
			return intialState
		case types.LOCATION_CLONED:
			return {
				...state,
				locationCloned: action.data,
			}
		case types.SET_CLONE_ID:
			return {
				...state,
				cloneId: action.id,
			}
		case types.SET_SHOW_SELECTED_LOCATION:
			return {
				...state,
				showSelectedLocations: !state.showSelectedLocations,
			}
		case types.SET_LOCATION_SEARCH_VALUE:
			return {
				...state,
				locationSearchValue: action.value,
			}
		case types.SET_SEARCH_VALUE_ON_CLICK:
			return {
				...state,
				searchValueOnClick: action.value,
			}
		case types.SET_ASSOCIATED_GROUP_SEARCH:
			return {
				...state,
				associatedGroupSearchValue: action.value,
			}
		default:
			return state
	}
}

export default locationReducer
